"use strict";
module.exports = {
    SUPPLIER_CUSTOMER_UPDATED: 'Kund uppdaterad',
    SUPPLIER_CUSTOMER_CREATED: 'Kund skapad',
    SUPPLIER_CUSTOMER_APPROVED: 'Kund godkänd',
    SUPPLIER_CUSTOMER_ACTIVATED: 'Kund aktiverad',
    SUPPLIER_CUSTOMER_DEACTIVATED: 'Kund inaktiverad',
    SUPPLIER_CUSTOMER_BLOCKED: 'Kund blockerad från köp',
    SUPPLIER_CUSTOMER_UNBLOCKED: 'Kund har fått tillbaka rätten att beställa',
    SUPPLIER_CUSTOMER_CONTACTS_UPDATED: 'Kundkontakter uppdaterad',
    SUPPLIER_CUSTOMER_OFC_CHANGED: 'Kundens leveranslager ändrat',
    SUPPLIER_CUSTOMER_ALCOHOL_LICENSE_APPROVED: 'Kundens alkoholtillstånd godkänt',
    SUPPLIER_CUSTOMER_ALCOHOL_LICENSE_REVOKED: 'Kundens alkoholtillstånd återkallat',
    SUPPLIER_CUSTOMER_DELIVERY_DETAILS_CHANGED: 'Kundens leveransuppgifter ändrade',
    SUPPLIER_CUSTOMER_INVOICE_DETAILS_CHANGED: 'Kundens fakturauppgifter ändrade',
    OFC_IN_CRM_UPDATED: 'Lagerställe uppdaterat',
    OFC_IN_CRM_CREATED: 'Lagerställe skapat',
    ACTIVITY_UPDATED: 'Aktivitet uppdaterad',
    ACTIVITY_CREATED: 'Aktivitet skapad',
    ACTIVITY_FINISHED: 'Aktivitet klar',
    USER_IN_CRM_UPDATED: 'Användaren uppdaterades',
    USER_IN_CRM_CREATED: 'Användaren skapades',
};
